var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11C22 17.0749 17.0758 22 11 22C4.92417 22 0 17.0749 0 11C0 4.92513 4.92417 0 11 0C17.0758 0 22 4.92513 22 11Z",
    fill: "url(#paint0_linear_1593_34738)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9994 6.28516L12.3464 9.31577H15.7137L13.0199 12.0096L14.0301 15.7137L10.9994 13.3566L7.96883 15.7137L8.97903 12.0096L6.28516 9.31577H9.6525L10.9994 6.28516Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1593_34738",
    x1: 11,
    y1: 0,
    x2: 11,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59D15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8CF46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.f3dfd35fe0333e04093c1ea3428a268b.svg";
export { ForwardRef as ReactComponent };